import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

const FundingPieProject = ({
  totalObtainedFunding,
  totalDesiredFundingWithFS = null,
  totalDesiredFunding,
  fees,
  devise,
  type,
  className,
}) => {
  const formatCurrency = (value) => {
    return parseFloat(value.toFixed(1)).toLocaleString("fr-FR") + " " + devise;
  };

  const dataTotal = [
    {
      name: "Total",
      value:
        totalObtainedFunding +
        (totalDesiredFundingWithFS
          ? totalDesiredFundingWithFS
          : totalDesiredFunding + fees),
      description:
        "Coût total projet (CTP) = " +
        formatCurrency(
          totalObtainedFunding +
            (totalDesiredFundingWithFS
              ? totalDesiredFundingWithFS
              : totalDesiredFunding + fees)
        ),
    },
  ];

  const data = [
    {
      name: "CO",
      value: totalObtainedFunding,
      description:
        "Contributions déjà obtenues (CO) = " +
        formatCurrency(totalObtainedFunding),
    },
    {
      name: "FS",
      value: totalDesiredFundingWithFS
        ? totalDesiredFundingWithFS - fees
        : totalDesiredFunding,
      description:
        "Financements souhaités (FS) = " +
        formatCurrency(
          totalDesiredFundingWithFS
            ? totalDesiredFundingWithFS - fees
            : totalDesiredFunding
        ),
    },
    // {
    //   name: "FSV",
    //   value: fees,
    //   description: "Frais de service Verdeo (FSV) = " + formatCurrency(fees),
    // },
  ];

  const data3 = [
    {
      name: "CO",
      value: totalObtainedFunding,
      description:
        "Contributions déjà obtenues (CO) = " +
        formatCurrency(totalObtainedFunding),
    },
    {
      name: "AC",
      value: totalDesiredFundingWithFS
        ? totalDesiredFundingWithFS
        : totalDesiredFunding + fees,
      description:
        "Appel à contributions (AC) = " +
        formatCurrency(
          totalDesiredFundingWithFS
            ? totalDesiredFundingWithFS
            : totalDesiredFunding + fees
        ),
    },
  ];

  const COLORS = ["#9dc95f", "#dd0000"];
  const COLORS3 = ["#9dc95f", "#ff0000"];

  const CustomTooltip = ({ active, payload }: any) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-2 border rounded shadow-md">
          <p className="text-[11px] m-0 whitespace-nowrap">
            {payload[0].payload.description}
          </p>
        </div>
      );
    }
    return <></>;
  };

  const CustomLabel = ({
    name,
    value,
    cx,
    cy,
    midAngle,
    outerRadius,
    type,
  }: any) => {
    const RADIAN = Math.PI / 180;
    const x = cx + (outerRadius + 20) * Math.cos(-midAngle * RADIAN);
    const y = cy + (outerRadius + 20) * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="#333"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
        fontSize={type === 1 ? 8 : 12}
        fontWeight="normal"
      >
        {formatCurrency(value)}
      </text>
    );
  };

  return (
    <div className={`${className}`}>
      <ResponsiveContainer width="100%" height="100%">
        {type === 2 ? (
          <PieChart width={730} height={250} className="chart-financement">
            <Pie
              data={dataTotal}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={25}
              fill="#fff"
              stroke="none"
              label={({
                cx,
                cy,
                midAngle,
                innerRadius,
                outerRadius,
                value,
              }) => {
                const RADIAN = Math.PI / 180;

                // Positionner le label exactement au centre de la portion
                const radius = (innerRadius + outerRadius) / 18; // Rayon médian
                const x = cx + radius * Math.cos(-midAngle * RADIAN);
                const y = cy + radius * Math.sin(-midAngle * RADIAN);

                return (
                  <text
                    x={x}
                    y={y}
                    fill="#878787"
                    textAnchor="middle"
                    dominantBaseline="central"
                    fontSize={12}
                  >
                    {value > 1000
                      ? Math.round(value / 1000) + "K"
                      : formatCurrency(value)}
                  </text>
                );
              }}
            />
            <Pie
              data={data3}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={37}
              outerRadius={47}
              fill="#82ca9d"
              label={<CustomLabel />}
              labelLine
            >
              {data3.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS3[index % COLORS3.length]}
                />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        ) : (
          <PieChart width={730} height={250} className="chart-financement">
            <Pie
              data={data3}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={37}
              outerRadius={47}
              fill="#82ca9d"
              label={<CustomLabel type={type} />}
              labelLine
            >
              {data3.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS3[index % COLORS3.length]}
                />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        )}
      </ResponsiveContainer>
    </div>
  );
};

export default FundingPieProject;
